var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtrw15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.17 16.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: white;\n        stroke-miterlimit: 10;\n        stroke-width:1px;\n      }\n\n      .cls-2 {\n        fill: white;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m3.52,5.51h-.02l-1.36.73-.2-.8,1.7-.91h.9v7.8h-1.02v-6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.04,5.42h-2.97l-.3,2c.18-.02.35-.05.64-.05.6,0,1.2.13,1.68.42.61.35,1.12,1.02,1.12,2,0,1.52-1.21,2.66-2.9,2.66-.85,0-1.57-.24-1.94-.48l.26-.8c.32.19.96.43,1.67.43,1,0,1.85-.65,1.85-1.69-.01-1.01-.68-1.73-2.24-1.73-.44,0-.79.05-1.08.08l.5-3.74h3.73v.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,1.32h12.76c2.3,0,4.16,2.13,4.16,4.75v5.33c0,2.62-1.86,4.75-4.16,4.75H0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.13,
    y1: 1.32,
    x2: 4.21,
    y2: 0.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.13,
    y1: 1.32,
    x2: 4.21,
    y2: 2.41
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtrw15);
export default __webpack_public_path__ + "static/media/btrw15.c09d1d2f023e551c40a7817cbb1e2e9b.svg";
export { ForwardRef as ReactComponent };